import {generateMethod, url} from 'shared/javascripts/api';

const PREFIX_URL = `${window.APP.apiURL}/_exclusive/prakerja`;
const PREFIX_COUPON_DEALS_URL = `${window.APP.apiURL}/coupon-deals`;
const NEO_PREFIX_URL = `${window.APP.apiURL}/_exclusive/neo`;
const INFO_PREFIX_URL = `${window.APP.apiURL}/info`;
const ARTICLE_PREFIX_URL = `${window.APP.apiURL}/cms/websites/${process.env.ARTICLES_WEBSITE_ID}`;

let mockInterfaces = {};

const interfaces = window.API.wrap(
  {
    getNeoConfig: generateMethod({
      prefix: NEO_PREFIX_URL,
      address: url`configs`,
      scope: 'user',
      method: 'post',
    }),
    getNeoToggles: generateMethod({
      prefix: NEO_PREFIX_URL,
      address: url`toggles`,
      scope: 'user',
      method: 'post',
    }),
    getDynamicSection: generateMethod({
      prefix: PREFIX_COUPON_DEALS_URL,
      address: url`sections`,
      scope: 'user',
      method: 'get',
    }),
    getMerchants: generateMethod({
      prefix: PREFIX_COUPON_DEALS_URL,
      address: url`merchants`,
      scope: 'user',
      method: 'get',
    }),
    getMerchantDetail: generateMethod({
      address: url`merchants/${'id'}`,
      prefix: PREFIX_COUPON_DEALS_URL,
      scope: 'user',
      method: 'get',
    }),
    getBanners: generateMethod({
      address: url`mitra/banners`,
      prefix: `${window.APP.apiURL}`,
      scope: 'user',
      method: 'get',
    }),
    getDeals: generateMethod({
      address: '',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getBestCourses: generateMethod({
      address: 'skus/best-packages',
      prefix: PREFIX_COUPON_DEALS_URL,
      scope: 'user',
      method: 'get',
    }),
    getCategories: generateMethod({
      address: url`categories`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getReviews: generateMethod({
      address: url`reviews`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    postOtpTransaction: generateMethod({
      address: url`otp-transactions`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    postFinalizeTransaction: generateMethod({
      address: url`transactions/${'id'}/finalizations`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    getCourses: generateMethod({
      address: url`courses`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getCourseDetail: generateMethod({
      address: url`courses/${'id'}`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getCapacity: generateMethod({
      address: url`courses/${'id'}/capacity`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getAddress: generateMethod({
      address: url`addresses`,
      prefix: INFO_PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaLatestTransaction: generateMethod({
      address: url`transactions/prakerja-latest`,
      prefix: PREFIX_COUPON_DEALS_URL,
      scope: 'user',
      method: 'get',
    }),
    getSubscribeStatus: generateMethod({
      address: url`courses/${'id'}/notifications`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    postSubscribeNotification: generateMethod({
      address: url`courses/${'id'}/notifications`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    deleteSubscribeNotification: generateMethod({
      address: url`courses/${'id'}/notifications`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'delete',
    }),
    getPrakerjaClosestCourses: generateMethod({
      address: 'closest',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaPurchasedCoupons: generateMethod({
      address: 'coupons',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getArticles: generateMethod({
      address: 'articles',
      prefix: ARTICLE_PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getArticleDetail: generateMethod({
      address: url`articles/${'article_id'}`,
      prefix: ARTICLE_PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaTransactions: generateMethod({
      address: 'transactions',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaTransactionDetail: generateMethod({
      address: url`transactions/${'id'}`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaGamificationEligibleCampaign: generateMethod({
      address: 'gamifications/eligible-campaign',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaGamificationCampaignTransactions: generateMethod({
      address: url`gamifications/campaigns/${'id'}/transactions`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'get',
    }),
    getPrakerjaGamificationWalletInquiry: generateMethod({
      address: 'gamifications/e-wallets/inquiry',
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    claimPrakerjaGamificationMission: generateMethod({
      address: url`gamifications/missions/${'id'}/claims`,
      prefix: PREFIX_URL,
      scope: 'user',
      method: 'post',
    }),
    ...mockInterfaces,
  },
  'xhrPublicKartuPrakerja'
);

export default interfaces;
